import { render } from "./bus.vue?vue&type=template&id=37ce8aaa"
const script = {}

import exportComponent from "/Users/ronjanackblad/Desktop/ST.SharedLibrary/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__